const dashboard = () => import("../components/dashboard/dashboard.vue");
const sensorDashboard = () => import("../components/sensor/list.vue");
const resellerDashboard = () => import("../components/dashboard/reseller.vue");
const sensors = () => import("../components/sensor/list.table.vue");
const sensorsFirmwareUpdates = () => import("../components/sensor/firmware/list.all.vue");
const applicationLogging = () => import("../components/logging/search.vue");
const sensorsAdd = () => import("../components/sensor/activate/assign.vue");
const paymentStatus = () => import("../components/sensor/activate/payment.status.vue");
const report = () => import("../components/report/report.vue");
const comments = () => import("../components/comments/list.vue");
const contacts = () => import("../components/tier3/contacts/list.contacts.vue");
const contactsAdd = () => import("../components/tier3/contacts/add.vue");
const contactsAdd2 = () => import("../components/tier3/contacts/add2.vue");
const contactsEdit = () => import("../components/tier3/contacts/edit.vue");
const alertingList = () => import("../components/alerting/list.vue");
const alertingAdd = () => import("../components/alerting/add.vue");
const contactsEditAssignments = () => import("../components/tier3/contacts/edit.vue");
const multiConfigureContacts = () => import("../components/tier3/contacts/assignment.multi.vue");
const alarms = () => import("../components/tier3/alarms.vue");
const profile = () => import("../components/profile/profile.vue");
const contextProfile = () => import("../components/profile/contextProfile.vue");
const deleteProfile = () => import("../components/profile/delete.vue");
const api = () => import("../components/api/api.vue");
const firmware = () => import("../components/firmware/versions.vue");
const fleetmap = () => import("../components/fleetmap/loader.vue");
const cronExpired = () => import("../components/api/cron.expired.vue");
const requisition = () => import("../components/requisition/requisition.vue");
const usersAdd = () => import("../components/profile/user.create.vue");
const activityLog = () => import("../components/activity/log.vue");
const permissions = () => import("../components/permissions/list.permissions.vue");
const usersAttach = () => import("../components/login/attach.vue");
const usersDetach = () => import("../components/login/detach.vue");
import Vue from 'vue'

let isTargetClient = [
    'or',
    ['context_exists', ['not', 'context_user_manage_others']],
    [['not', 'user_manage_others']]
];


let isTargetReseller = [
    'or',
    [['not', 'context_exists'], 'user_manage_others', ['not', 'user_manage_everybody']],
    ['context_user_manage_others', ['not', 'context_user_manage_everybody']]
];

let canTargetAssignUnit = [
    'sensor_add',
    ['or', ['not', 'user_manage_everybody'], 'context_exists']
];

let itemReturnDashboard = {
    target: 'dashboard',
    meta: {
        inMainmenu: true,
        label: 'menu.back_dashboard',
        icon: 's7-left-arrow',
        permissions: []
    }
};

let itemReturnContacts = {
    target: 'contacts',
    meta: {
        inMainmenu: true,
        label: 'menu.back_contacts',
        icon: 's7-left-arrow',
        permissions: []
    }
};

let itemReturnAlerting = {
    target: 'alerting',
    meta: {
        inMainmenu: true,
        label: 'menu.back_alerting',
        icon: 's7-left-arrow',
        permissions: []
    }
};

export const routes = [
    {
        name: 'dashboard',
        path: '/',
        component: dashboard,
        meta: {
            inMainmenu: true,
            label: 'menu.overview',
            icon: 's7-display1',
            permissions: []
        },
        submenu: [
            {
                target: 'usersAdd',
                meta: {
                    inMainmenu: true,
                    label: 'menu.create_account',
                    icon: 's7-plus',
                    permissions: [
                        'user_create',
                        ['or', ['not', 'context_exists'], 'context_user_create']
                    ]
                }
            },
            {
                target: 'usersAttach',
                meta: {
                    inMainmenu: true,
                    label: 'menu.assign_account',
                    icon: 's7-add-user',
                    permissions: [
                        'user_edit_other',
                        ['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']],
                        ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not','user_manage_everybody']]]
                    ]
                }
            },
            {
                target: 'usersDetach',
                meta: {
                    inMainmenu: true,
                    label: 'menu.detach_account',
                    icon: 's7-delete-user',
                    permissions: [
                        'user_edit_other',
                        ['or', ['context_exists', 'context_user_manage_others']],
                        ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not','user_manage_everybody']]]
                    ]
                }
            },
            {
                target: 'sensorsAdd',
                meta: {
                    inMainmenu: true,
                    label: 'menu.add_unit',
                    icon: 's7-plus',
                    permissions: [
                        canTargetAssignUnit
                    ],
                }
            },
            {
                target: 'multiConfContacts',
                meta: {
                    inMainmenu: true,
                    label: 'menu.conf_contacts',
                    icon: 's7-users',
                    permissions: [
                        'contact_manage',
                        isTargetClient
                    ],
                }
            }
        ]
    }, /*
    {
        name: 'dashboardAlias',
        path: '/',
        component: dashboard,
        meta: {
            inMainmenu: false,
            permissions: []
        }
    },*/
    {
        name: 'dashboardWrapper',
        path: '/Kunde/:id',
        component: dashboard,
        meta: {
            inMainmenu: false,
            permissions: [
                'user_manage_others'
            ]
        }
    },
    {
        name: 'resellerDashboard',
        path: '/Kunder',
        component: resellerDashboard,
        meta: {
            inMainmenu: false,
            permissions: [
                'user_manage_others'
            ]
        }
    },
    {
        name: 'fleetmap',
        path: '/Kort',
        component: fleetmap,
        meta: {
            inMainmenu: true,
            label: 'menu.fleetmap',
            icon: 's7-map',
            permissions: [
                'sensor_view',
                ['or', isTargetClient, isTargetReseller]
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'alarms',
        path: '/Alarmer',
        component: alarms,
        meta: {
            inMainmenu: true,
            label: 'menu.alarms',
            icon: 's7-speaker',
            permissions: [
                'sensor_view',
                isTargetClient
            ]
        }
    },
    {
        name: 'report',
        path: '/Rapport',
        component: report,
        meta: {
            inMainmenu: true,
            label: 'menu.report',
            icon: 's7-note2',
            permissions: [
                //'report_view',
                isTargetClient
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'activity',
        path: '/Aktivitet',
        component: activityLog,
        meta: {
            inMainmenu: false,
            permissions: [
                'context_exists',
                'activity_view'
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'sensors.firmware.updates',
        path: '/Hardware',
        component: sensorsFirmwareUpdates,
        meta: {
            inMainmenu: false,
            permissions: [
                'context_exists',
                'user_manage_others'
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'application.logs',
        path: '/Udvikler/Logs',
        component: applicationLogging,
        meta: {
            inMainmenu: false,
            permissions: [
                'context_exists',
                'user_manage_others'
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'permissions',
        path: '/Rettigheder',
        component: permissions,
        meta: {
            inMainmenu: true,
            label: 'menu.permissions',
            icon: 's7-users',
            permissions: [
                'context_exists',
                'user_edit_other'
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'contacts',
        path: '/Kontaktpersoner',
        component: contacts,
        meta: {
            inMainmenu: true,
            label: 'menu.contacts',
            icon: 's7-users',
            permissions: [
                'contact_manage',
                isTargetClient,
            ]
        },
        submenu: [
            {
                target: 'contacts.add',
                meta: {
                    inMainmenu: true,
                    label: 'menu.contacts_add',
                    icon: 's7-plus',
                    permissions: [
                        'contact_manage',
                        isTargetClient
                    ]
                }
            }
        ]
    },
    {
        name: 'contacts.edit',
        path: '/Kontaktpersoner/:id/Rediger',
        component: contactsEdit,
        meta: {
            inMainmenu: false,
            permissions: [
                'contact_manage'
            ]
        }
    },
    /*{
        name: 'contacts.assignments.edit',
        path: '/Kontaktpersoner/:id/Enheder',
        component: contactsEditAssignments,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'contact_manage'
            ]
        },
        submenu: [
            itemReturnContacts
        ]
    },*/
    {
        name: 'contacts.add',
        path: '/Kontaktpersoner/Opret',
        component: contactsAdd,
        alias: '/Kontaktpersoner/Opret/:sensor',
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'contact_manage',
                isTargetClient
            ]
        },
        submenu: [
            itemReturnContacts
        ]
    },
    {
        name: 'contacts.add.sensor2',
        path: '/Kontaktpersoner/Opret/2',
        component: contactsAdd2,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'contact_manage',
                isTargetClient,
                'sensor_view_extra'
            ]
        },
        submenu: [
            itemReturnContacts
        ]
    },
    {
        name: 'comments',
        path: '/Kommentarer',
        component: comments,
        meta: {
            inMainmenu: true,
            label: 'menu.comments',
            icon: 's7-comment',
            permissions: [
                'comment_manage',
                'context_exists'
            ]
        }
    },
    {
        name: 'alerting',
        path: '/Alarmering',
        component: alertingList,
        meta: {
            inMainmenu: true,
            noLabel: false,
            label: 'menu.alerting',
            icon: 's7-call',
            permissions: [
                /*['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']],
                ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not', 'user_manage_everybody']]]*/
                isTargetReseller
            ]
        },
        submenu: [
            itemReturnDashboard,
            {
                target: 'alerting.add',
                meta: {
                    inMainmenu: true,
                    label: 'menu.alerting_add',
                    icon: 's7-plus',
                    permissions: [
                        isTargetReseller
                    ]
                }
            }
        ]
    },
    {
        name: 'alerting.add',
        path: '/Alarmering/Opret',
        component: alertingAdd,
        alias: '/Alarmering/Opret/:sensor',
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                isTargetReseller
            ]
        },
        submenu: [
            itemReturnAlerting
        ]
    },
    {
        name: 'profile',
        path: '/Profil',
        component: profile,
        meta: {
            inMainmenu: false,
            label: 'menu.profile',
            icon: 's7-tools',
            permissions: []
        }
    },
    {
        name: 'profileOwn',
        path: '/Profil',
        component: profile,
        meta: {
            inMainmenu: true,
            label: 'menu.profile',
            icon: 's7-tools',
            permissions: [
                ['not','context_exists']
            ]
        }
    },
    {
        name: 'contextProfile',
        path: '/Info',
        component: contextProfile,
        meta: {
            inMainmenu: true,
            label: 'menu.profile',
            icon: 's7-tools',
            permissions: [
                'context_exists'
            ]
        }
    },
    {
        name: 'deleteProfile',
        path: '/Opsig',
        component: deleteProfile,
        meta: {
            inMainmenu: false,
            label: 'menu.profile_delete',
            icon: 's7-remove',
            permissions: [
                'user_delete'
            ]
        }
    },
    {
        name: 'sensors.table',
        path: '/Enheder',
        component: sensors,
        meta: {
            inMainmenu: false,
            label: 'menu.units',
            icon: 's7-users',
            permissions: [
                'sensor_view'
            ]
        }
    },
    {
        name: 'api',
        path: '/API',
        component: api,
        meta: {
            inMainmenu: false,
            permissions: [
                'api_manage'
            ]
        }
    },
    {
        name: 'firmware',
        path: '/Firmware',
        component: firmware,
        meta: {
            inMainmenu: false,
            permissions: [
                'api_manage'
            ]
        }
    },
    {
        name: 'expired',
        path: '/Cron/Expired',
        component: cronExpired,
        meta: {
            inMainmenu: false,
            permissions: [
                'api_manage'
            ]
        }
    },
    {
        name: 'usersAdd',
        path: '/Konti/Opret',
        component: usersAdd,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'user_create',
                ['or', ['not', 'context_exists'], 'context_user_create']
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'usersAttach',
        path: '/Konti/Tilknyt',
        component: usersAttach,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'user_edit_other',
                ['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']],
                ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not','user_manage_everybody']]]
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'usersDetach',
        path: '/Konti/Fjern',
        component: usersDetach,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'user_edit_other',
                ['or', ['context_exists', 'context_user_manage_others'], [['not', 'context_exists'], 'user_manage_others']],
                ['or', ['context_exists', ['not', 'context_user_manage_everybody']], [['not', 'context_exists'], ['not','user_manage_everybody']]]
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'sensorsAdd',
        path: '/Sensor/:sensor?/Opret',
        component: sensorsAdd,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                canTargetAssignUnit
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'cardPaymentStatus',
        path: '/Betaling/Sensor/:sensor/:status',
        component: paymentStatus,
        meta: {
            inMainmenu: false,
            noLabel: true,
            permissions: [
                canTargetAssignUnit
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'multiConfContacts',
        path: '/Konfigurer/Alarmmodtagere',
        component: multiConfigureContacts,
        meta: {
            inMainmenu: true,
            noLabel: true,
            permissions: [
                'contact_manage',
                isTargetClient,
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    },
    {
        name: 'requisitions',
        path: '/Rekvisitioner',
        component: requisition,
        meta: {
            inMainmenu: false,
            noLabel: true,
            permissions: [
                'user_manage_everybody',
            ]
        },
        submenu: [
            itemReturnDashboard
        ]
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js